import { PayrollCalendarFormValues } from '@/modules/employer/components/SetupEmployer/Features/PayrollCalendar/payrollCalendar.types';
import { storeCreator } from '@/utils/store/store.utils';

interface State {
  calendarParams?: PayrollCalendarFormValues;
  handleSetCalendarParams: (value: PayrollCalendarFormValues) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  calendarParams: undefined,

  handleSetCalendarParams: (value) => set((state) => ({
    ...state,
    calendarParams: value,
  })),

  handleReset: () => set((state) => ({
    ...state,
    calendarParams: undefined,
  })),
}));
